// @ts-strict-ignore
import clsx from 'clsx'

import { TPromoHeroInfoBlock } from '@/shared/types/deprecated-types'
import { Col, Row } from '@/shared/ui/Grid'
import { Image } from '@/shared/ui/Image'

import { HeroInfoContent } from './components/HeroInfoContent/HeroInfoContent'
import { HeroInfoTabs } from './components/HeroInfoTabs/HeroInfoTabs'

import cls from './HeroInfoBlock.module.scss'

/**
 * Hero banner with info, links and triggers
 *
 * @param props
 */
export const HeroInfoBlock = (props: TPromoHeroInfoBlock): JSX.Element => {
	const { tabItems, imgWidth, title, imgSrc, imgHeight, bgColor } = props

	return (
		<section
			className={cls.heroInfoBlock}
			id="b2b_hero-section"
			style={{ backgroundColor: bgColor ? bgColor : `#efeff1` }}>
			{tabItems && <HeroInfoTabs tabItems={tabItems} />}
			<Row>
				<Col lg={imgWidth ? 12 : 14} xs={24}>
					<HeroInfoContent title={title} {...props} />
				</Col>
				<Col lg={imgWidth ? 12 : 8} xs={24}>
					<div className={clsx(cls.heroInfoBlock__imgWrap, `heroInfoBlock__imgWrap`)}>
						<Image alt={title} src={imgSrc} width={imgWidth || 648} height={imgHeight || 512} />
					</div>
				</Col>
			</Row>
		</section>
	)
}
